import React, { useState, useEffect, useCallback } from 'react'
import { Template } from '../../Components/Template/template'
import { Link } from 'react-router-dom'
import {
    AlertType, ClientesSearchBox, LanctoCartao, classBorderLabelDark, classDivBackground, classDivBody,
    classDivTitulo, classInput, classInputDark, classLabel, classLabelDark, classWeigthDiv, classbtColunasAzul, classbtColunasVermelho
} from '../../Utils/Types'
import { IoCloseCircleOutline, IoSearch } from 'react-icons/io5'
import { SearchBox } from '../../Components/SearchBox/SearchBox'
import moment from 'moment'
import { BsBoxArrowInLeft } from 'react-icons/bs'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { FaTrashAlt } from 'react-icons/fa'
import { ClientesService } from '../Clientes/ClientesService'
import { LanctoCartaoService } from './LanctoCartaoService'
import { GridLanctoCartaoExcluido } from '../../Components/GridExcluidos/GridLanctoCartaoExcluido'

export const LanctoCartaoExcluidos = () => {

    const [lanctoCartaoExcluidas, setLanctoCartaoExcluidas] = useState<LanctoCartao[]>([])

    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    let dateI = moment()
        .utcOffset('-03:00')
        .add(-31, 'days')
        .format('YYYY-MM-DD')

    let dateF = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD')

    const [datai, setDatai] = useState(dateI)
    const [dataf, setDataf] = useState(dateF)

    const [nome_cliente, setNome_Cliente] = useState("")

    //----------------------------------------------------------------------------------- ATRIBUTOS e USEEFFECT ----------------------------------------------------------------------------//
    const GetAttributes = async () => {
        setLoading(true)
        try {

            const relatorio = {
                dt_ini: datai,
                dt_fim: dataf,
                nome_cliente: nome_cliente,
            }

            const retAPI = await LanctoCartaoService.FilterExcluidas(relatorio)
            if (retAPI.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(retAPI.msg || "")

            } else {
                setLanctoCartaoExcluidas(retAPI.data || [])
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage("Não foi possível buscar os clientes")

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 0)
        }
    }

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

    }, [])

    const handleTabPress = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    const handleKeyPressEnter = async (e: any) => {
        if ((e.code === "Enter" || e.code === "NumpadEnter") && !loading) {
            await handleFilterClick()
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleTabPress)
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {
            document.removeEventListener('keydown', handleTabPress)
            document.removeEventListener('keydown', handleKeyPressEnter)
        }
    }, [datai, dataf, nome_cliente, loading])

    useEffect(() => {
        GetAttributes()
    }, [])

    //-------------------------------------------------------------------------------------------- INPUTS ----------------------------------------------------------------------------//
    const handleChangeNomeCliente = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNome_Cliente(e.target.value)
    }

    const handleChangeDtInicio = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
    }

    const handleChangeDtFim = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
    }

    //--------------------------------------------------------------------------------------- AÇÕES E STATES ----------------------------------------------------------------------------//
    const handleFilterClick = async () => {

        setVisible(false)
        setLoading(true)
        setLanctoCartaoExcluidas([])

        try {

            const relatorio = {
                dt_ini: datai,
                dt_fim: dataf,
                nome_cliente: nome_cliente,
            }

            const retAPI = await LanctoCartaoService.FilterExcluidas(relatorio)
            if (retAPI.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(retAPI.msg || "")

            } else {
                setLanctoCartaoExcluidas(retAPI.data || [])
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage("Não foi possível buscar os lançamentos excluídos")

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 500)
        }
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    const limparCampoFilter = () => {
        setNome_Cliente('')
    }

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div id="div-body" role='button' className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`${classDivTitulo} mb-1 flex flex-row`}>

                        <div className={`flex items-center w-full`}>
                            <FaTrashAlt className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Lançamentos de Cartão Excluídos</span>
                        </div>

                        <div className={`flex justify-end items-center px-2 ${classWeigthDiv}`}>
                            <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/lanctoCartao" className={`${classbtColunasVermelho} h-9`}>
                                <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                            </Link>
                        </div>

                    </div>

                    <div className={`w-auto h-auto rounded-md bg-white dark:bg-slate-600 border dark:border-slate-800 shadow-sm shadow-slate-400 dark:shadow-slate-800 cursor-default py-4`}>

                        <div className={`w-auto h-auto grid grid-cols-12 gap-3 px-3`}>

                            <div className={`relative col-span-12 xl:col-span-4 2xl:col-span-6 mt-2`}>
                                <input id='nome_cliente_delete' className={`${classInput} ${classInputDark}`} type='text' inputMode='text' placeholder=' ' autoComplete='off' value={nome_cliente} onChange={handleChangeNomeCliente} />
                                <label htmlFor="nome_cliente_delete" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Nome do Cliente</label>

                                <button onClick={limparCampoFilter} className={`absolute right-2 bottom-0 top-0 text-slate-400 outline-none ${nome_cliente === '' ? 'invisible' : 'visible'}`}>
                                    <IoCloseCircleOutline size="25px" />
                                </button>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <input id="data_inicial_lanctoCartao" className={`${classInput} ${classInputDark} ${datai === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={datai} disabled={loading} onChange={handleChangeDtInicio} />
                                <label htmlFor="data_inicial_lanctoCartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data de Exclusão Inicial</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <input id="data_final_cheque_lanctoCartao" className={`${classInput} ${classInputDark} ${dataf === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={dataf} disabled={loading} onChange={handleChangeDtFim} />
                                <label htmlFor="data_final_cheque_lanctoCartao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data de Exclusão Final</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-2`}>
                                <button tabIndex={-1} disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} `} onClick={handleFilterClick} >
                                    <span className={`w-full h-full flex justify-center items-center`}>
                                        {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {!loading && `Pesquisar`} {loading && `Aguarde`}
                                    </span>
                                </button>
                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800`}>
                        <GridLanctoCartaoExcluido lanctoCartao={lanctoCartaoExcluidas} />
                    </div>

                </div>

            </div>

        </Template>
    )
}